import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({providedIn: 'root'})
export class DictItemService extends BaseService {

  private url = 'api/dict-item';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  getByDictCodeAndItemCode(dictCode, code):Observable<any> {
    const url = `${this.getUrl()}/search-code`;
    return this.http.get<any>(url, {params: {dictCode: dictCode, code: code}}).pipe(
      tap(_ => this.log(`search-code`)),
      catchError(this.handleError<any>(`search-code`))
    );
  }

  getByDictCodeAndItemCodes(dictCode, codes, allowEnglish):Observable<any> {
    const url = `${this.getUrl()}/search-Value`;
    let result=this.http.get<any>(url, {params: {dictCode: dictCode, codes: codes, allowEnglish: allowEnglish}}).pipe(
      tap(_ => this.log(`search-Value`)),
      catchError(this.handleError<any>(`search-Value`))
    );
    return result
  }
}

